export default __webpack_public_path__ + "locales/pt/ConvertDialog.json?hash=e32d99ea02325f3de498e4c4f3c2dabc";